var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagicWandGradient = function SvgMagicWandGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#magic-wand-gradient_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#magic-wand-gradient_svg__b)",
    d: "M.209 18.784a.715.715 0 0 0 1.01 1.01l2.12-2.12-1.01-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#magic-wand-gradient_svg__c)",
    d: "m16.51 8.106-.938-1.257.504-1.485a1.134 1.134 0 0 0-1.438-1.437l-1.485.503-1.257-.937a1.134 1.134 0 0 0-1.811.923l.02 1.568-1.28.905c-.767.542-.579 1.728.318 2.008l.727.226-6.713 6.712 1.01 1.01 6.713-6.712c.237.764.257.931.485 1.172a1.134 1.134 0 0 0 1.749-.127l.905-1.28 1.583.02c.93 0 1.466-1.063.908-1.812"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#magic-wand-gradient_svg__d)",
    d: "M17.637 10.804a.586.586 0 0 0-.829.829l.623.622a.586.586 0 1 0 .828-.828z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#magic-wand-gradient_svg__e)",
    d: "M19.414 7.547h-.88a.586.586 0 1 0 0 1.172h.88a.586.586 0 0 0 0-1.172"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#magic-wand-gradient_svg__f)",
    d: "M14.139 11.945a.586.586 0 0 0-.586.586v.88a.586.586 0 1 0 1.172 0v-.88a.586.586 0 0 0-.586-.586"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#magic-wand-gradient_svg__g)",
    d: "M8.366 3.193a.586.586 0 1 0 .829-.829l-.623-.622a.586.586 0 0 0-.828.828z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#magic-wand-gradient_svg__h)",
    d: "M11.864 2.052a.586.586 0 0 0 .586-.586v-.88a.586.586 0 1 0-1.172 0v.88c0 .323.263.586.586.586"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#magic-wand-gradient_svg__i)",
    d: "M6.589 6.445h.88a.586.586 0 0 0 0-1.172h-.88a.586.586 0 0 0 0 1.172"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "magic-wand-gradient_svg__b",
    x1: 0,
    x2: 3.339,
    y1: 18.334,
    y2: 18.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#EB476B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#7D3DDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "magic-wand-gradient_svg__c",
    x1: 3.157,
    x2: 16.737,
    y1: 10.055,
    y2: 10.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#EB476B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#7D3DDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "magic-wand-gradient_svg__d",
    x1: 16.637,
    x2: 18.431,
    y1: 11.53,
    y2: 11.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#EB476B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#7D3DDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "magic-wand-gradient_svg__e",
    x1: 17.948,
    x2: 20,
    y1: 8.133,
    y2: 8.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#EB476B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#7D3DDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "magic-wand-gradient_svg__f",
    x1: 13.553,
    x2: 14.725,
    y1: 12.971,
    y2: 12.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#EB476B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#7D3DDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "magic-wand-gradient_svg__g",
    x1: 7.572,
    x2: 9.366,
    y1: 2.467,
    y2: 2.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#EB476B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#7D3DDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "magic-wand-gradient_svg__h",
    x1: 11.278,
    x2: 12.45,
    y1: 1.026,
    y2: 1.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#EB476B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#7D3DDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "magic-wand-gradient_svg__i",
    x1: 6.003,
    x2: 8.055,
    y1: 5.859,
    y2: 5.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#EB476B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#7D3DDC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "magic-wand-gradient_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgMagicWandGradient;